// @flow
import React from 'react';

export const ErrorList = ({errors}) => {
	const items = (errors || []).map((item, index) => <li key={index}>{item}</li>);
	return <ul>{items}</ul>;
};
